export const AUTH_BASE_PATH = "/api/auth"
export const TURNSTILE_SITE_KEY: string | undefined = import.meta.env.VITE_LAT_TURNSTILE_SITE_KEY
